import { useGeneralSetupQuery } from "Settings/Modules/GeneralSetup/Api/Query/useGeneralSetupQuery";
import { GeneralSetupForm } from "Settings/Modules/GeneralSetup/Components/Forms/GeneralSetupForm";
import { Loading } from "Shared/Components/Loading/Loading";
import { Box, Stack, Typography } from "@mui/material";
import { useOutletContext } from "react-router";

type Props = {
	paramsMarketId: number;
	paramsVerticalId: number;
};

export const GeneralSetupEditPage = () => {
	const { paramsMarketId, paramsVerticalId }: Props = useOutletContext();
	const { data, isLoading } = useGeneralSetupQuery(
		paramsMarketId,
		paramsVerticalId,
	);

	return (
		<Stack spacing={2} p={2} pr={0} width="100%">
			<Typography variant="h4">General Setup</Typography>
			{isLoading && (
				<Stack width="100%">
					<Loading />
				</Stack>
			)}
			{data && (
				<Box width="100%">
					<GeneralSetupForm
						data={data}
						marketId={paramsMarketId}
						verticalId={paramsVerticalId}
					/>
				</Box>
			)}
		</Stack>
	);
};
